<template>
    <div>
        <navbar :title="text_title" :left-text="right_text"></navbar>
        <div class="input">
            <input type="text" name="" placeholder="请输入需绑定的手机号" id="">
        </div>
        <van-cell-group >
            <van-cell @click="phonebind" is-link  title="手机号绑定" value="暂无" />
            <van-cell @click="techstubind" is-link  title="家长/学生绑定" value="暂无" />
        </van-cell-group>
         <van-cell-group >
            <van-cell @click="namebind" is-link  title="实名认证" value="暂无" />
        </van-cell-group>
        <van-cell-group >
            <van-cell @click="gradebind" is-link  title="年级" value="暂无" />
            <van-cell @click="classbind" is-link  title="班级" value="暂无" />
            <van-cell @click="schoolbind" is-link  title="学校" value="暂无" />
            <van-cell @click="yearbind" is-link  title="入学年份" value="暂无" />
        </van-cell-group>
        
        <!-- 手机号绑定 -->
        <van-popup v-model="show">内容</van-popup>
    </div>
</template>

<script>
import Vue from 'vue';
import { Cell, CellGroup } from 'vant';
Vue.use(Cell);
Vue.use(CellGroup);
import { Icon } from 'vant';
Vue.use(Icon);
import { Popup } from 'vant';
Vue.use(Popup);
import navbar from '../../components/Navbar'
export default {
    components:{
        navbar
    },
  data(){
    return{
        text_title:'账号绑定',
        right_text:'123'
    }
  },
  mounted(){

  },
  methods: {
      phonebind(){
        
      },
      techstubind(){

      },
      namebind(){

      },
      schoolbind(){
        
      },
      classbind(){

      },
      gradebind(){

      },
      yearbind(){

      },
      
  }
}
</script>

<style scoped>

input{
    width: 100%;
    line-height: 45px;
    border:none;
    background-color: #fff;
    margin: 15px 0;
    text-indent: 20px;
}
</style>


// WEBPACK FOOTER //
// src/pages/binding/binding.vue